var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bottombar"},[_c('div',{staticStyle:{"margin-right":"20px","margin-left":"20px"}},[_vm._v("当前经度:"+_vm._s(_vm.lng))]),_vm._v(" "),_c('div',[_vm._v("当前纬度:"+_vm._s(_vm.lat))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4161f21a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/bottombar.vue
// module id = null
// module chunks = 